<template>
<div id="clientManage">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'clientManage'
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/clientManage/index.vue